import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { CheckCircle2 } from 'lucide-react';
import { CTAButton } from './ui/CTAButton';
export function WhatYouGet() {
  const items = [{
    title: 'Ebook Maestro',
    desc: 'La guía paso a paso para las 3 fases: Contención, Desintoxicación y Reconstrucción.'
  }, {
    title: "Checklist de Emergencia 'No le escribas'",
    desc: 'El protocolo de 4 pasos para detener el impulso de contacto en menos de 90 segundos.'
  }, {
    title: 'Tracker de 21 Días',
    desc: 'Seguimiento visual para blindar tu progreso y evitar recaídas.'
  }, {
    title: 'Inventario del Nuevo Yo',
    desc: 'Plantillas para recuperar la identidad que perdiste durante la relación.'
  }];
  return <section className="py-16 md:py-24 px-4 bg-brand-dark" data-id="element-203">
      <div className="max-w-3xl mx-auto" data-id="element-204">
        <FadeIn data-id="element-205">
          <h3 className="font-serif text-3xl md:text-4xl text-white text-center mb-12" data-id="element-206">
            Lo que recibes hoy
          </h3>
        </FadeIn>
        <div className="grid sm:grid-cols-2 gap-6 mb-12" data-id="element-207">
          {items.map((item, i) => <FadeIn key={i} delay={i * 0.1} data-id="element-208">
              <div className="h-full p-6 rounded-2xl bg-[#1e293b] border border-white/5 hover:border-brand-amber/30 transition-colors flex flex-col" data-id="element-209">
                <div className="flex items-center gap-3 mb-4" data-id="element-210">
                  <CheckCircle2 className="w-6 h-6 text-brand-amber flex-shrink-0" data-id="element-211" />
                  <h4 className="text-white font-bold text-lg" data-id="element-212">{item.title}</h4>
                </div>
                <p className="text-brand-text/80 leading-relaxed flex-grow" data-id="element-213">
                  {item.desc}
                </p>
              </div>
            </FadeIn>)}
        </div>
        <FadeIn delay={0.4} data-id="element-214">
          <div className="flex justify-center" data-id="element-215">
            <CTAButton scrollTo="precio" data-id="element-216" />
          </div>
        </FadeIn>
      </div>
    </section>;
}